import { CountryFlagWithLabel } from "@/components/CountryFlag";
import { InputPhoneNumber } from "@/components/Input/Phone/InputPhoneNumber";
import type { PhoneValue } from "@/components/Input/Phone/state.machine";
import { useFormattedPhoneNumber } from "@/hooks/useFormattedPhoneNumber";
import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value: PhoneValue;
  onChange: (value: PhoneValue) => void;
};

/**
 * Card-based Form / PhoneItem
 */
export const CFormPhoneItem = buildCFormItem((props: Props) => {
  const { countryCode, formattedFull } = useFormattedPhoneNumber(props.value);

  return (
    <CFormItemBase
      {...props}
      readComponent={
        <CountryFlagWithLabel countryCode={countryCode} label={formattedFull} />
      }
      writeComponent={
        <InputPhoneNumber
          value={props.value}
          onChange={props.onChange}
          required={props.required}
        />
      }
    />
  );
});
